import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'

import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  // 没有VIP身份
  none = 0,
  new = 1,
  VIP,
  SVIP,
  SSVIP,
  SSSVIP,
  SSSSVIP,
}
export enum subPageTypeEnum {
  suit = 1,
  reward,
  customer,
}
export enum rewardPageTypeEnum {
  Gold = 1,
  Privilege,
}
export enum ModalTypeEnum {
  openBox = 1,
  getReward,
  rank20,
}
// 查看自己大 R 动态充值任务活动配置 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41419343
export const vip_recharge_config = createAsyncThunk(
  'BigRRechargeTask_vip_recharge_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'vip_level'
          | 'vip_item_list'
          | 'count_down'
          | 'reward_coins_list'
          | 'reward_privilege_list'
          | 'vip_customer_info'
          | 'vip_level_list'
          | 'vip_list'
          | 'in_privilege_idx'
          | 'is_deployed'
        >
      >
    >(
      '/live/activity/vip_recharge_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取金币奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41419416
export const vip_recharge_coin_reward = createAsyncThunk(
  'BigRRechargeTask_vip_recharge_coin_reward',
  async (arg: {id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string; status: number}>>(
      '/live/activity/vip_recharge_coin_reward',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取特权奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41419432
export const vip_recharge_privilege_reward = createAsyncThunk(
  'BigRRechargeTask_vip_recharge_privilege_reward',
  async (arg: {id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string; status: number}>>(
      '/live/activity/vip_recharge_privilege_reward',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export enum rewardStatusEnum {
  未完成 = 0,
  可领取,
  已完成,
}
interface reward_coins_item {
  id: number
  coins: number
  status: rewardStatusEnum
  can_get_coins: number
}
interface privilege_item {
  url: string
  name: string
}
interface reward_privilege_item {
  id: number
  coins: number
  status: rewardStatusEnum
  privilege_list: Array<privilege_item>
}
interface vip_level_item {
  id: number
  coins: number
  // 其实只有两个状态 0未完成，2已完成
  status: rewardStatusEnum
  desc: string
}

interface InitialStateType {
  vip_level?: PageTypeEnum
  // 每个等级 需要的展示的金币内容
  vip_item_list?: Array<{now_coins: number; upgrade_coins: number}>
  count_down?: number
  // 金币任务列表
  reward_coins_list?: Array<reward_coins_item>
  // 特权任务列表
  reward_privilege_list?: Array<reward_privilege_item>
  vip_customer_info?: {
    mid: number
    avatar: string
    telephone: string
    zy_id: string
  }
  vip_level_list?: Array<vip_level_item>
  // vip等级tab new的等级可以看全部VIP的内容，已经是VIP的无法看new的
  vip_list?: Array<{key: number; text: string}>
  // 从1开始
  in_privilege_idx?: number
  // 是否在配置中
  is_deployed?: boolean
}

const initialState: InitialStateType = {}

export const BigRRechargeTaskSlice = createSlice({
  name: 'BigRRechargeTask',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 主页
    builder.addCase(vip_recharge_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default BigRRechargeTaskSlice.reducer
export const BigRRechargeTaskActions = BigRRechargeTaskSlice.actions
